import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
export default class GradientOverlay extends Base {
  /**
   * GradientOverlay config.
   */
  static config = {
    name: 'GradientOverlay',
    refs: ['gradient'],
  };

  /**
   *
   */
  mounted() {
    this.updateHeight();
  }

  /**
   * Resized hook.
   */
  resized() {
    this.updateHeight();
  }

  /**
   * Update the gradient height based on parent and next sibling.
   */
  updateHeight() {
    const parent = this.$el.closest('section');
    if (!parent) return;

    const parentHeight = parent.offsetHeight;
    const nextSibling = parent.nextElementSibling;
    const nextSiblingHeight = nextSibling ? nextSibling.offsetHeight : 0;

    // Height = parent height + 100% of next sibling
    const totalHeight = parentHeight + nextSiblingHeight;

    this.$refs.gradient.style.height = `${totalHeight}px`;
  }
}
